
  import { InfoDialogPlugin } from '@/plugins/GlobalDialog'
  import { Component, Vue } from 'vue-property-decorator'
  import DialogEvent from '@/plugins/GlobalDialog/models/interfaces/SuccessDialogEvent'

  @Component
  export default class InfoDialog extends Vue {
    private message: string = ''
    private visible: boolean = false
    private onConfirm: VoidFunction|false = false

    private beforeMount(): void {
      InfoDialogPlugin.$eventBus.$on('show-info-dialog', (params: DialogEvent) => {
        this.show(params.message, params.onConfirm)
      })
    }

    private hide(): void {
      this.visible = false
    }

    private confirm(): void {
      if (typeof this.onConfirm === 'function') {
        this.onConfirm()
      }

      this.hide()
    }

    private show(message: string, onConfirm?: VoidFunction): void {
      this.visible = true
      this.message = message

      if (onConfirm) {
        this.onConfirm = onConfirm;
      }
    }
  }
